import axios from 'axios';
import _ from 'lodash';
import { SubmissionError } from 'redux-form';
import { push } from 'connected-react-router';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { PAGE_NAME } from '../../config/pageNames';
import { handleServerSideErrors } from '../../utils/USUtils';
import { NETWORK, } from '../../../framework/App/AppConstants';
import setUrl from '../../../framework/App/SetUrl';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { PYMT_SECURITY_PAGE } from './PaymentSecurityPageConstants';

export const submitPaymentSecurity = (data) => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;
    const currentExperiment = _.get(serverData, 'elmo.PaymentSecurity');

    return axios
        .request({
            url: PAGE_NAME.PAYMENT_SECURITY_SUBMIT,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data: {
                agreeToPymtSecurity: _.isNil(data) ? false : data.agreeToPymtSecurity
            }
        })
        .then(async(response) => {
            const pymtSec = _.get(response, 'data.paymentSecurity', false);
            dispatch(setServerData({enrollPymtSecurity: pymtSec}));
            // used by FPTI analytics to track payment security signups
            window.hasPaymentSecurity = pymtSec;
            dispatch(spinnerClose());
            if (currentExperiment === PYMT_SECURITY_PAGE) {
                dispatch(push(PAGE_NAME.TERMS_PAGE));
            }
        })
        .catch(error => {
            // show server-side errors on form
            if (error instanceof SubmissionError) {
                return Promise.reject(error);
            }
            capeLog && capeLog('response:error: PaymentSecuritySubmitAction return' + (error && error.message));

            // if (handleRedirect(error && error.response)) {
            //     return;
            // }
            // TODO: need to add handling for not authorized error and redirect to signin

            if (_.get(error, 'response.data.err', false)) {
                dispatch(setServerData({ errorModel: _.get(error, 'response.data', {}) }));
                dispatch(push(PAGE_NAME.ERROR_PAGE));
                dispatch(spinnerClose());
            } else {
                // should never be here
                capeLog && capeLog('response:error: unexpected error response for payment security submit');
                setUrl(window, PAGE_NAME.ERROR_PAGE);
            }
        });
};
